"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionSchema = void 0;
const zod_1 = require("zod");
const tags_schema_1 = require("./tags.schema");
exports.questionSchema = zod_1.z
    .object({
    id: zod_1.z.string().uuid().describe("Unique identifier of a question in the format of UUID"),
    title: zod_1.z.string().describe("Title of a question"),
    statement: zod_1.z.string().describe("A statement to agree or disagree with, should not be phrased as a question with question mark"),
    detail: zod_1.z.string().describe("A detailed description or an explanation of a question").optional(),
    tags: tags_schema_1.tagsSchema.optional(),
})
    .strict()
    .describe("Question for a calculator");
